import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Box, CircularProgress } from '@mui/material';

const quotes = [
	{
		statement: "O mercado de ações é um dispositivo para transferir dinheiro dos impacientes para os pacientes.",
		author: "Warren Buffett",
		source: "Entrevista à Forbes"
	},
	{
		statement: "Nunca dependa de uma única fonte de renda. Invista para criar uma segunda.",
		author: "Warren Buffett",
		source: "Carta aos acionistas da Berkshire Hathaway, 2007"
	},
	{
		statement: "Preço é o que você paga. Valor é o que você recebe.",
		author: "Warren Buffett",
		source: "Carta aos acionistas da Berkshire Hathaway, 2008"
	},
	{
		statement: "O investidor inteligente é aquele que vende para os otimistas e compra dos pessimistas.",
		author: "Benjamin Graham",
		source: "O Investidor Inteligente"
	},
	{
		statement: "O verdadeiro investidor é aquele que deseja que suas ações caiam para que ele possa comprar mais a preços baixos.",
		author: "Benjamin Graham",
		source: "O Investidor Inteligente"
	},
	{
		statement: "A paciência combinada com disciplina é o maior superpoder no mundo dos investimentos.",
		author: "Charlie Munger",
		source: "Daily Journal Annual Meeting, 2019"
	},
	{
		statement: "É notável o quão rentável pode ser simplesmente se sentar quieto em ações bem escolhidas.",
		author: "Charlie Munger",
		source: "Entrevista ao The Wall Street Journal"
	},
	{
		statement: "Invista naquilo que você conhece.",
		author: "Peter Lynch",
		source: "Beating the Street"
	},
	{
		statement: "As ações caem e sobem, mas se você fizer sua lição de casa, terá sucesso.",
		author: "Peter Lynch",
		source: "One Up on Wall Street"
	},
	{
		statement: "Não procure a agulha no palheiro. Apenas compre o palheiro inteiro.",
		author: "John Bogle",
		source: "The Little Book of Common Sense Investing"
	},
	{
		statement: "O tempo é o amigo do investidor, e o inimigo do especulador.",
		author: "John Bogle",
		source: "Stay the Course"
	},
	{
		statement: "Compre boas ações pagadoras de dividendos e mantenha-as para o resto da vida.",
		author: "Luiz Barsi",
		source: "Entrevista à Exame, 2021"
	},
	{
		statement: "Você não precisa de muito dinheiro para começar, mas precisa de tempo e disciplina.",
		author: "Luiz Barsi",
		source: "Canal Inteligência Financeira (YouTube), 2022"
	},
	{
		statement: "A Bolsa não é um cassino, é uma fábrica de renda.",
		author: "Luiz Barsi",
		source: "Palestra na B3, 2020"
	},
	{
		statement: "Tempo no mercado é mais importante que timing de mercado.",
		author: "Nick Murray",
		source: "Simple Wealth, Inevitable Wealth"
	},
	{
		statement: "A coisa mais perigosa que você pode fazer é não assumir riscos.",
		author: "Ray Dalio",
		source: "Principles"
	},
	{
		statement: "A diversificação é a única proteção gratuita no mercado.",
		author: "Harry Markowitz",
		source: "Modern Portfolio Theory, 1952"
	},
	{
		statement: "Investir deve ser mais parecido com ver tinta secar ou grama crescer. Se quiser emoção, pegue seu dinheiro e vá para Las Vegas.",
		author: "Paul Samuelson",
		source: "The New York Times, 1998"
	},
	{
		statement: "Você ganha dinheiro esperando, não agindo.",
		author: "Charlie Munger",
		source: "Berkshire Hathaway Annual Meeting, 2004"
	},
	{
		statement: "O retorno dos investimentos é determinado mais pelo comportamento do investidor do que pela performance dos investimentos.",
		author: "Carl Richards",
		source: "The Behavior Gap"
	},
	{
		statement: "A primeira regra é não perder dinheiro. A segunda é nunca esquecer a primeira.",
		author: "Warren Buffett",
		source: "Entrevistas diversas"
	},
	{
		statement: "Comprar ações de uma empresa sem entender seus negócios é como jogar pôquer sem ver as cartas.",
		author: "Peter Lynch",
		source: "One Up on Wall Street"
	},
	{
		statement: "Ganhar dinheiro na bolsa exige muito mais psicologia do que inteligência.",
		author: "Howard Marks",
		source: "The Most Important Thing"
	}
];

const QuoteRotator = () => {

	const [currentQuote, setCurrentQuote] = useState(quotes[Math.floor(Math.random() * quotes.length)]);

	useEffect(() => {
		const interval = setInterval(() => {
		const random = Math.floor(Math.random() * quotes.length);
			setCurrentQuote(quotes[random]);
		}, 5000); // Altera a cada 6 segundos

		return () => clearInterval(interval);
	}, []);

	return (
		<Box display="flex" justifyContent="center" alignItems="center" minHeight="30vh">
			<Card sx={{ maxWidth: 700, p: 2, borderRadius: 4, boxShadow: 4 }}>
				<CardContent>
					<Typography variant="h6" gutterBottom>
						"{currentQuote.statement}"
					</Typography>
					<Typography variant="subtitle1" color="text.secondary">
						— {currentQuote.author}
					</Typography>
					<Typography variant="caption" color="text.secondary">
						Fonte: {currentQuote.source}
					</Typography>
					<Box display="flex" flexDirection="column" alignItems="center" gap={2} paddingTop={2}>
						<CircularProgress color="primary" />
						<Typography variant="body1" color="text.secondary">
							Realizando sua busca... Aguarde um instante!
						</Typography>
					</Box>			
				</CardContent>
			</Card>
		</Box>
	);
};

export default QuoteRotator;
